var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "batchAddFee" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "addTable",
      },
      [
        _vm.addType === 2
          ? _c(
              "div",
              [
                _c(
                  "el-card",
                  { staticClass: "mb5" },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("collectionCenter.basicInformation"))
                        ),
                      ]),
                    ]),
                    _c("BasicInfoForm", {
                      attrs: {
                        type: _vm.type,
                        "add-batch-fee": _vm.addBatchFee,
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _c(
          "el-card",
          { staticClass: "mb5" },
          [
            _c("div", { attrs: { slot: "header" }, slot: "header" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("receivablePayable.CostSummary"))),
              ]),
            ]),
            _vm.type === 1
              ? _c("BasicTable", {
                  ref: "basicTableRef",
                  attrs: {
                    "add-type": _vm.addType,
                    "query-form": _vm.queryForm,
                    "query-fee-param": _vm.queryFeeParam,
                    "fee-type-option": _vm.feeTypeOption,
                    "expense-sub-list": _vm.addBatchFee.expenseSubList,
                  },
                })
              : _vm._e(),
            _vm.type === 2
              ? _c("VehicleTable", {
                  ref: "vehicleTableRef",
                  attrs: {
                    "add-type": _vm.addType,
                    "query-form": _vm.queryForm,
                    "query-fee-param": _vm.queryFeeParam,
                    "fee-type-option": _vm.feeTypeOption,
                    "vehicle-expense-sub-list":
                      _vm.addBatchFee.vehicleExpenseSubList,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm.type === 2
          ? _c(
              "el-card",
              { staticClass: "mb5" },
              [
                _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("receivablePayable.FeeBreakdown"))),
                  ]),
                ]),
                _c("VehicleFeeTable", {
                  attrs: {
                    "table-list": _vm.addBatchFee.vehicleExpenseLoadInfoVOList,
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "footer" },
      [
        _c(
          "el-button",
          {
            attrs: { size: "small" },
            on: {
              click: function ($event) {
                return _vm.saveData(1)
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("collectionCenter.close")))]
        ),
        _vm.type === 1
          ? _c(
              "el-button",
              {
                attrs: { type: "primary", size: "small" },
                on: {
                  click: function ($event) {
                    return _vm.saveData(2)
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("basicData.Save")))]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }